"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.EmptyPicture = function (props) { return (React.createElement("svg", __assign({ width: "71%", height: "78%", viewBox: "0 0 61 67", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M0,65.4388545 C0,47.7801858 10.7105078,38 30.332158,38 C49.9538082,38 60.6643159,47.7801858 60.75,65.4388545 L60.75,67.25 L0,67.25 L0,65.4388545 Z" }),
        React.createElement("path", { d: "M46.5,16.3421053 C46.5,25.9342105 39.4125,33.75 30.75,33.75 C22.0875,33.75 15,25.9342105 15,16.3421053 C15,7.01644737 21.7375,0 30.75,0 C39.7625,0 46.5,7.01644737 46.5,16.3421053 Z" })))); };
//# sourceMappingURL=empty-picture.js.map